import React from 'react';
import Navbar from './Nav';
import Footer from './Footer';
import Sidebar from './Sidebar';
import './App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';import { faCaretRight } from '@fortawesome/free-solid-svg-icons';
import svg1 from './images/svg1.svg'
import svg2 from './images/svg2.png'
import svg3 from './images/svg3.png'
import { Link } from "react-router-dom";

const Services = () => {
  
    return (
      <div className="overflow-x-hidden text-white background elegant  ">
        <Navbar />
        <div className="w-full container px-5 block lg:flex py-24 mx-auto  justify-between">
          <div className="w-full lg:w-1/3 mx-2">
            <Sidebar />
          </div>
          <div className="w-full my-24 lg:my-0 lg:w-2/3 mx-auto">
            <div
              className="md:bg-zinc-900 rounded-xl  container px-5 py-10"
              data-aos="fade-up"
              data-aos-duration="1500"
            >
              <p className="text-lg">
                <span className="text-lime-500 md:text-5xl text-3xl Riesling  font-bold ">
                  Our Best Service!
                </span>
                <br />
                <br />
                Ready to transform your online presence and provide your users
                with an exceptional digital experience? <br />
                <br />
                Our comprehensive web design, development, and UX design
                services are meticulously crafted to meet your unique
                requirements and deliver outstanding, measurable results. We
                specialize in creating websites that not only look great but
                also drive conversions and enhance user satisfaction. From
                initial concept and design to development, testing, and
                deployment, we work closely with you every step of the way.
                Contact us today to begin a collaborative partnership and build
                a website that truly captivates your audience, effectively
                converts visitors into customers, and leaves a lasting, positive
                impression.{" "}
              </p>

              <div
                class="container px-5 py-24 mx-auto flex flex-wrap"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <div class="w-full mx-auto">
                  <div class="flex flex-wrap w-full bg-zinc-700 rounded-2xl py-5  mb-10 px-10 relative">
                    <div class=" relative z-10 w-full">
                      <img
                        alt="gallery"
                        class="w-24 object-cover h-24 mx-auto object-center "
                        src={svg1}
                      />
                      <h2 class="text-3xl text-lime-500 font-bold Riesling title-font my-5 text-center">
                        Web Design & Template Create
                      </h2>
                      <p class="leading-relaxed text-center">
                        <FontAwesomeIcon icon={faCaretRight} className="mr-2" />
                        Convert Figma, XD, PSD to html. <br />
                        <br />
                        <FontAwesomeIcon icon={faCaretRight} className="mr-2" />
                        Design & build a custom template. <br />
                        <br />
                        <FontAwesomeIcon icon={faCaretRight} className="mr-2" />
                        Convert Html to React & Nextjs. <br />
                        <br />
                        <FontAwesomeIcon icon={faCaretRight} className="mr-2" />
                        Well-maintained consistency
                      </p>
                    </div>
                  </div>
                  <div
                    class="md:flex md:flex-wrap block mx-auto"
                    data-aos="fade-up"
                    data-aos-duration="1500"
                  >
                    <div class="px-2  w-11/12 my-5 md:my-0 mx-auto md:w-1/2 rounded-2xl ">
                      <div class="flex flex-wrap w-full bg-zinc-700 rounded-2xl py-5 px-10  relative">
                        <div class="text-center relative z-10 w-full">
                          <img
                            alt="gallery"
                            class="w-20 object-cover h-20 object-center block "
                            src={svg2}
                          />
                          <h2 class="text-3xl text-lime-500 font-bold Riesling title-font my-5 text-left">
                            Web Apps
                          </h2>
                          <p class="leading-relaxed text-left">
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />{" "}
                            Application using MERN. <br />
                            <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Dynamic Single-Page Applications <br /> <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            E-Commerce Websites. <br />
                            <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Task Management Tools
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="px-2  w-11/12 my-5 md:my-0 mx-auto md:w-1/2 rounded-2xl "
                      data-aos="fade-up"
                      data-aos-duration="1500"
                    >
                      <div class="flex flex-wrap w-full bg-zinc-700 rounded-2xl py-5 px-10  relative">
                        <div class="text-center relative z-10 w-full">
                          <img
                            alt="gallery"
                            class="w-20 object-cover h-20 object-center block ml-auto "
                            src={svg3}
                          />
                          <h2 class="text-3xl text-lime-500 font-bold Riesling title-font my-5 text-right">
                            UI Design
                          </h2>
                          <p class="leading-relaxed text-right">
                            {" "}
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Maintaining consistency <br />
                            <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Focus on defining user interaction. <br />
                            <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Attention to accessibility. <br />
                            <br />
                            <FontAwesomeIcon
                              icon={faCaretRight}
                              className="mr-2"
                            />
                            Design by wireframes.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
};

export default Services;